import React from 'react';
import PropTypes from 'prop-types';

// components
import { FormattedPrice } from './FormattedPrice';
import { priceLabel, discountLabel } from './messages/priceMessages';

// styles
import styles from './PriceAmount.scss';

// helpers
import classnames from 'classnames';

export function PriceAmount({
    amount,
    currency,
    discount,
    hasNetPrice,
    hasSalePrice,
    hasPrivateOffer,
    quantityDisplay,
    showLabel,
    expiration,
    type,
}) {
    const className = classnames({
        [styles.retail]: type === 'RETAIL',
        [styles.net]: type === 'NET',
        [styles.hasNet]: hasNetPrice,
        [styles.hasSale]: hasSalePrice,
        [styles.hasPrivateOffer]: hasPrivateOffer,
    });

    return (
        <div className={className} data-tn={`price-${type.toLowerCase()}`}>
            {/* Price */}
            <span className={styles.price} data-tn="price-amount">
                <FormattedPrice value={amount} currency={currency} />
            </span>
            {/* List Price */}
            {showLabel && (
                <span className={styles.label} data-tn="price-list-price">
                    {priceLabel(type)}
                </span>
            )}
            {/* Quantity */}
            {quantityDisplay && (
                <span className={styles.label} data-tn="price-quantity-display">
                    {quantityDisplay}
                </span>
            )}
            {/* Percent Off */}
            {discount && (
                <span className={styles.discount} data-tn="price-discount">
                    {discountLabel(discount)}
                </span>
            )}
            {/* Expiration Date for Private Offers */}
            {expiration && (
                <span className={styles.expiration} data-tn="price-offer-expiration-date">
                    {expiration}
                </span>
            )}
        </div>
    );
}

PriceAmount.propTypes = {
    amount: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
    discount: PropTypes.number,

    type: PropTypes.string,
    hasNetPrice: PropTypes.bool,
    hasSalePrice: PropTypes.bool,
    hasPrivateOffer: PropTypes.bool,

    // options
    quantityDisplay: PropTypes.string,
    showLabel: PropTypes.bool,
    expiration: PropTypes.node,
};

PriceAmount.defaultProps = {
    amount: 0,
    type: 'RETAIL',
};
